export const LogoMark = ({ className = "w-8 h-8" }) => (
  <svg viewBox="0 0 40 40" className={className} aria-hidden="true">
    <path d="M20 5L33 12.5V27.5L20 35L7 27.5V12.5Z" fill="none" stroke="currentColor" strokeWidth="2.2" />
    <path d="M7 12.5L20 20L33 12.5" fill="none" stroke="currentColor" strokeWidth="1.6" />
    <path d="M20 20V35" stroke="#D96B27" strokeWidth="2.6" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-3">
    <LogoMark className="w-8 h-8 text-[#f4f5f7]" />
    <span className="font-display text-lg font-bold tracking-tight leading-none">
      Interior<span className="text-[#d96b27]">Box</span>
    </span>
  </span>
);
